import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { urlApiServer, urlApiServerImage } from "../../Config/Config";
import { fetchWithCache } from "../../utils/cacheService";
import "./BrochureDigital.css";

function BrochureDigital() {
    const [brochureData, setBrochureData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const urlGetbrochure = `${urlApiServer}brochure-digitals?populate=*`;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        setIsLoading(true);
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                // Usar fetchWithCache para obtener datos con caché
                const BrochureResponse = await fetchWithCache(urlGetbrochure, requestOptions);
                
                if (process.env.NODE_ENV === 'development') {
                    console.log('info del BrochureResponse: ', BrochureResponse?.data?.[0]?.Bronchure);
                }

                // Asegurar que siempre sea un array
                if (Array.isArray(BrochureResponse?.data) && BrochureResponse.data.length > 0) {
                    // Mapear para extraer las imágenes de cada brochure
                    const brochureImages = BrochureResponse.data
                        .flatMap(item => item.Bronchure || []) // Aplanar el array de brochures
                        .filter(img => img != null);
                    
                    if (process.env.NODE_ENV === 'development') {
                        console.log('Imágenes del brochure procesadas:', brochureImages);
                    }
                    setBrochureData(brochureImages);
                } else {
                    setBrochureData([]);
                }
            } catch (error) {
                if (process.env.NODE_ENV === 'development') {
                    console.log('el backend esta temporalmente desactivado');
                }
                setBrochureData([]); // Asegurar que sea un array vacío en caso de error
            } finally {
                setIsLoading(false);
            }
        })();
    }, [urlGetbrochure]);

    return (
        <div className="brochureDigitalContainer">
            <div className="brochureDigitalHeader">
                <div className="brochureDigitalHeaderContent">
                    <h1 className="brochureDigitalTitle">BROCHURE DIGITAL</h1>
                    <button 
                        className="brochureDigitalBackButton"
                        onClick={() => navigate(-1)}
                    >
                        ← Volver
                    </button>
                </div>
            </div>
            <div className="brochureDigitalImagesContainer">
                {isLoading ? (
                    <div className="brochureDigitalLoading">
                        <div className="spinner"></div>
                        <p>Cargando imágenes...</p>
                    </div>
                ) : brochureData.length > 0 ? (
                    brochureData.map((item, index) => (
                        <div key={index} className="brochureDigitalImageWrapper">
                            <img
                                src={urlApiServerImage + item?.url}
                                alt={`Brochure ${index + 1}`}
                                className="brochureDigitalImage"
                                loading="lazy"
                            />
                        </div>
                    ))
                ) : (
                    <div className="brochureDigitalEmpty">
                        <p>No hay imágenes disponibles en el brochure digital.</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default BrochureDigital;

